export enum ExistingWorkerCheckStatus{
    NONE = 0,
    EXISTS_ALL_MATCH = 1,
    EXISTS_DETAILS_NOT_MATCH = 2,
    DOES_NOT_EXIST = 3,
}